const isUmbracoNullDate = (date: string): boolean => {
  return date === '0001-01-01T00:00:00';
};

export default isUmbracoNullDate;
